import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer,
} from "@ngrx/store";
import { environment } from "../../../environments/environment";

import * as formAuth from "./auth.reducer";

export interface AppState {
  auth: formAuth.AuthState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: formAuth.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
